import {HStack, Text, TextProps} from 'platform/foundation';

import {ReactNode} from 'react';

import {isNilOrEmpty} from 'ramda-adjunct';

type TimerRowType = {
  label: string;
  labelProps?: TextProps;
  value?: string | ReactNode;
  valueProps?: TextProps;
};
export const ReservationRow = (props: TimerRowType) => {
  if (isNilOrEmpty(props.value)) {
    return null;
  }
  return (
    <HStack justify="space-between" align="center">
      <Text size="xSmall" {...props.labelProps}>
        {props.label}
      </Text>
      {typeof props.value === 'string' ? (
        <Text size="xSmall" {...props.valueProps}>
          {props.value}
        </Text>
      ) : (
        props.value
      )}
    </HStack>
  );
};
